




import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'SDA',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		SdaCheck(): boolean {
			return this.SdaCheckPzn === 0;
		},
		HasVozidlo(): boolean {
			return !!this.VozidloId || !!this.OvozidloId || (!!this.NvozidloId || !!this.NvskladId);
		},
	},
});
